// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"261":"2907dd6c","323":"04c91a45","408":"04c91a45","424":"72313cad","887":"2907dd6c","893":"04c91a45","894":"c8cc362f"}[chunkId] + ".chunk.css";
};